import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import {debounceTime, switchMap, map, catchError, tap, distinctUntilChanged} from 'rxjs/operators';
import {Trabajador} from "../../models/trabajador.model";

@Component({
    selector: 'app-trabajador-autocomplete',
    templateUrl: './trabajador-autocomplete.component.html',
    styleUrls: ['./trabajador-autocomplete.component.scss']
})
export class TrabajadorAutocompleteComponent implements OnInit {

    @Input() label = 'Buscar Trabajador';
    @Input() searchFn?: (query: string) => Observable<any[]>; // función de búsqueda personalizada
    @Output() trabajadorSelected = new EventEmitter<any>();   // callback al seleccionar
    @Input() placeholder = 'Escribe para buscar...';
    @Input() minLength = 2;

    trabajadorSearchCtrl = new FormControl();
    filteredTrabajadores: Observable<any[]>;
    isSearching = false;
    private isSelecting = false; // <-- para evitar doble búsqueda
    private selectedTrabajador: any = null;

    constructor(private trabajadorService: Trabajador) {}

    ngOnInit(): void {
        this.filteredTrabajadores = this.trabajadorSearchCtrl.valueChanges.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            tap(value => {
                if (typeof value === 'string' && !this.isSelecting) {
                    this.isSearching = true;
                }
            }),
            switchMap(value => {
                if (!value || this.isSelecting || typeof value !== 'string') {
                    return of([]); // evita buscar cuando seleccionas
                }

                const query = value.trim();

                const fn = this.searchFn
                    ? this.searchFn
                    : (q: string) => this.defaultSearch(q);

                return fn(query).pipe(
                    tap(() => (this.isSearching = false)),
                    catchError(() => {
                        this.isSearching = false;
                        return of([]);
                    })
                );
            })
        );
    }

    private defaultSearch(query: string): Observable<any[]> {
        const searchObj = { busqueda: query, pagina: 1, registros: 10 };
        return this.trabajadorService.busquedaTrabajadores(searchObj).pipe(
            map(res => res?.data ?? [])
        );
    }

    displayTrabajador(trabajador: any): string {
        return trabajador
            ? trabajador.trabajador_nombrescompletos ||
            `${trabajador.trabajador_nombres ?? ''} ${trabajador.trabajador_apellidos ?? ''}`.trim()
            : '';
    }

    onTrabajadorSelected(event: any) {
        this.isSelecting = true;
        this.selectedTrabajador = event.option.value;
        this.trabajadorSelected.emit(this.selectedTrabajador);

        setTimeout(() => (this.isSelecting = false), 200);
    }

    clearSelection(): void {
        this.selectedTrabajador = null;
        this.trabajadorSearchCtrl.setValue('', { emitEvent: false });
        this.trabajadorSelected.emit(null);
    }

    hasSelection(): boolean {
        return !!this.selectedTrabajador;
    }
}
